import React, { Component } from 'react'

export default class Marker extends Component {

  render() {
    return (
      <div className='google-maps-marker-container'>
        <img src="../../../assets/img/icons/location-marker-red.png" alt=""  className='google-maps-marker'/>

        {
          this.props.text ?
            <span>{this.props.text}
            </span>
            : null
        }

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App/components/GoogleMaps/Marker.js